(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'SnippetPrompt',
	};

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$modal.find('.filter-snippets').on('click', function _filterSnippets(e) {
			var search_term     = $modal.find('#snippetprompt-search_term').val();
			var search_category = $modal.find('#snippetprompt-category').val();
			var tab             = $modal.find('li.active').data('type');

			if (search_term === '' && search_category === '') {
				// gotta select something homie
				Adzuki.StatusMessage('Error', 'Please enter at least 1 filter criteria in order to proceed.');
				return false;
			}

			$modal.find('.form-loader').css('visibility', 'visible');
			$('#' + tab).html('<p class="pad20-vert-top">Loading search results...</p>');

			Adzuki.Ajax.post('/Snippets/snippetsPrompt/',
				{
					search  : search_term,
					category: search_category
				}
			).then(function success(response) {
				$modal.find('.modal-body').html(response);
				Adzuki.Form.initAjaxForm('SnippetPrompt');
			});
		});

		$modal.find('.snippet-filter-clear').on('click', function _clearSearch(e) {
			e.preventDefault();

			$('.filtered-snippets').html('<p class="pad20-vert-top">Clearing search results...</p>');

			Adzuki.Ajax.get('/Snippets/snippetsPrompt')
			.then(function _showSnippetPrompt(html) {
				$modal.find('.modal-body').html(html);
				Adzuki.Form.initAjaxForm('SnippetPrompt');
			});
		});
	};
}(jQuery, window.Adzuki || {}));